import toast, { ToastOptions, Toaster } from 'react-hot-toast';

import { CheckIcon, CloseIcon } from '@componentLibrary/Icon';

import './Toaster.scss';

export { Toaster };

export type TToastPromiseMessageParameters = Parameters<typeof toast.promise>[1];
type TToastOptions = Parameters<typeof toast.promise>[2];

function errorWithCustomIcon(message: string, options?: ToastOptions) {
    return toast.error(message, {
        ...options,
        icon: (
            <div className="w-[16.67px] h-[16.67px] rounded-full bg-sienna-500 flex items-center justify-center flex-shrink-0">
                <CloseIcon
                    className="w-3 h-3 text-white"
                    style={{ strokeWidth: 1, stroke: 'white' }}
                />
            </div>
        ),
    });
}

function successWithCustomIcon(message: string, options?: ToastOptions) {
    return toast.success(message, {
        ...options,
        icon: (
            <div className="w-[16.67px] h-[16.67px] rounded-full bg-aqua-500 flex items-center justify-center flex-shrink-0">
                <CheckIcon
                    className="w-3 h-3 text-white"
                    style={{ strokeWidth: 1, stroke: 'white' }}
                />
            </div>
        ),
    });
}

function toastPromiseOverride<T>(
    promise: Promise<T>,
    messages: TToastPromiseMessageParameters,
    opts: TToastOptions = {},
) {
    const loading =
        messages?.loading == null
            ? {
                  className: 'toaster message-is-null',
              }
            : {};

    toast.promise(promise, messages, {
        ...opts,
        className: 'toast',
        loading,
        success: {
            duration: 3000,
            ...(opts.success || {}),
        },
    });
}

export default {
    ...toast,
    error: errorWithCustomIcon,
    success: successWithCustomIcon,
    promise: toastPromiseOverride,
};
